// extracted by mini-css-extract-plugin
export default {"vertical":"CheckboxGroup_vertical__1ihge"};